import script from "./ZhCoreFunctionsTab1.vue?vue&type=script&setup=true&lang=ts"
export * from "./ZhCoreFunctionsTab1.vue?vue&type=script&setup=true&lang=ts"

import "./ZhCoreFunctionsTab1.vue?vue&type=style&index=0&id=5a1e60bd&lang=scss&scoped=true"

import exportComponent from "/root/workspace/dec_website_mQOS/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a1e60bd"]])

export default __exports__